<template>
  <div class="home" >
    <!-- <v-app-bar app color="primary" dark>
      <v-tabs fixed-tabs background-color="indigo" dark>
        <v-tab @click="swapComponent('aboutMe')">
          About Me
        </v-tab>
        <v-tab @click="swapComponent('pixelfie')">
          Pixelfie
        </v-tab>
        <v-tab @click="swapComponent('jikomap')">
          Jikomap
        </v-tab>
        <v-tab @click="swapComponent('arcake')">
          ARCakeDivider
        </v-tab>
      </v-tabs>
    </v-app-bar> -->

    <v-content>
      <component v-bind:is="currentComponent"></component>
    </v-content>
  </div>
</template>

<script>
import AboutMe from "@/components/AboutMe.vue";
import Pixelfie from "@/components/Pixelfie.vue";
import JikoMap from "@/components/JikoMap.vue";
import ARCakeDivider from "@/components/ARCakeDivider.vue";
export default {
  data: () => ({
    currentComponent: "aboutMe"
  }),
  components: {
    aboutMe: AboutMe,
    pixelfie: Pixelfie,
    jikomap: JikoMap,
    arkace: ARCakeDivider
  },

  methods: {
    swapComponent: function(component) {
      this.currentComponent = component;
    }
  }
};
</script>
